import { useCallback, useMemo, useRef } from "react";

/**
 * 用于替换useCallback
 */
const useEvent = <Callback extends (...args: any) => any>(callback?: Callback) => {
  const callbackRef = useRef(callback);

  callbackRef.current = useMemo(() => callback, [callback]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(
    ((...args) => {
      if (callbackRef.current) {
        return callbackRef.current(...args);
      }
    }) as NonNullable<Callback>,
    []
  );
};

export default useEvent;
